export const REACT_APP_VAM_SAML = process.env.REACT_APP_VAM_SAML
export const REACT_APP_VAM_SAML_OMDC = process.env.REACT_APP_VAM_SAML_OMDC
export const REACT_APP_VAM_ENDPOINT = process.env.REACT_APP_VAM_ENDPOINT
export const REACT_APP_KSHEMA_POC2=`${process.env.REACT_APP_KSHEMA_URL}/v1`
export const REACT_APP_KSHEMA_POC1=process.env.REACT_APP_KSHEMA_URL
export const CLIENT_ID=process.env.REACT_APP_CMS_CLIENT_ID
export const CLIENT_ID_OMDC=process.env.REACT_APP_OMDC_CLIENT_ID
export const token_ID = process.env.REACT_APP_CMS_TENANT_ID
export const token_ID_OMDC = process.env.REACT_APP_OMDC_TENANT_ID
export const tokenClientSecret= process.env.REACT_APP_CMS_SECRET
export const tokenScope=process.env.REACT_APP_CMS_SCOPE
export const survey_image_base_url = process.env.REACT_APP_SURVEY_IMAGE_BASE_URL
export const redirectURI = process.env.REACT_APP_REDIRECT_URI
//Below lists are context text for each module


export const REACT_APP_VAM_CONTEXT_CALCULATE = "kcalculationservice/api/v1/CalculationService";
export const REACT_APP_VAM_CONTEXT_INGESTION = "kclaimingestion/api/v1/claimIngestion";
export const REACT_APP_VAM_CONTEXT_DOCUMENT = "kdocumentservice/api/v1/document";
export const REACT_APP_VAM_CONTEXT_FIELD = "kfieldsurveyservice/api/v1/FieldSurveyService";
export const REACT_APP_VAM_CONTEXT_GIS = "kgissurveyservice/api/v1/GISSurveyService";
export const REACT_APP_VAM_CONTEXT_SURVEYOR = "ksurveyorandqcmasterservice/api/v1/SurveyorAndQCMasterService";
export const REACT_APP_VAM_CONTEXT_VENDOR = "kvendormasterservice/api/v1/VendorMasterService";
export const REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT = "kuserrolemanagment/api/v1";
export const REACT_APP_VAM_CONTEXT_QC = "kqcservice/api/v1/qcProcess";
export const REACT_APP_VAM_CONTEXT_LITIGATION = "kmoreoptionsservice/api/v1/MoreOptionsService";
export const REACT_APP_VAM_CONTEXT_PAYMENT = "kpaymentservice/api/v1/PaymentService";
export const REACT_APP_VAM_CONTEXT_AUTHORIZATION = "kauthorizationservice/kshema/authentication/v1";
export const REACT_APP_VAM_CONTEXT_APPROVAL = "kbatchapprovalservice/api/v1/BatchApproval";
export const REACT_APP_VAM_CONTEXT_PAYMENT_UPLOAD = "kpaymentuploadservice/api/v1/paymentuploadservice";
export const REACT_APP_VAM_CONTEXT_INDEMNITY = "kmasterservice/api/v1/MasterService/indemnity";
export const REACT_APP_VAM_CONTEXT_COMPENSATION = "kmasterservice/api/v1/MasterService/compensation";
export const REACT_APP_VAM_CONTEXT_EXCESS = "kmasterservice/api/v1/MasterService/excess";
export const REACT_APP_VAM_CONTEXT_MASTER = "kmasterservice/api/v1/MasterService";
export const REACT_APP_IMAGE_GEO_TAG = process.env.REACT_APP_IMAGE_GEO_TAG;
export const REACT_APP_VAM_CONTEXT_MASTER_ANIMAL_ATTACK = "kmasterservice/api/v1/MasterService/animal-attack";
export const REACT_APP_VAM_CONTEXT_MASTER_LOSS_RESERVE = "kmasterservice/api/v1/MasterService/loss-reserve";
export const REACT_APP_VAM_CONTEXT_PHOTO_COORDINATE = "kgissurveyservice/api/v1/GISSurveyService/photo-coordinates";
export const REACT_APP_SAW_CCE_SEARCH = "api/ncip/v1/saw/cce/search";
export const REACT_APP_IU_NAMES = "api/ncip/v1/saw/cce/iu-master";
export const REACT_APP_IMAGE_GEO_TAG_CLAIM = process.env.REACT_APP_IMAGE_GEO_TAG_CLAIM;
export const REACT_APP_CUSTOMER_ENDORSEMENT_INFORMATION_SHEET= "azure-file-service/v1.1";
export const REACT_APP_PROPOSAL_CKYC_LAND_FORM ="ops-azure-file-service/v1.1/"